import type {AddressRequest, Customer, CustomerRead} from "../../customer-management/services/customerTypes";

export const usersTagTypes: UsersTagType[] = ["UsersList"];
export type UsersTagType = "UsersList";
export type UsersListApiResponse = /** status 200  */ PaginatedUserListRead;
export type UsersListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type UsersCreateApiResponse = /** status 201  */ UserRead;
export type UsersCreateApiArg = {
  createRequest: UserRequest;
};
export type UsersRetrieveApiResponse = /** status 200  */ UserRead;
export type UsersRetrieveApiArg = {
  /** A unique integer value identifying this User. */
  id: number;
};
export type UsersUpdateApiResponse = /** status 200  */ UserRead;
export type UsersUpdateApiArg = {
  /** A unique integer value identifying this User. */
  id: number;
  updateRequest: UserRequest;
};
export type UsersPartialUpdateApiResponse = /** status 200  */ UserRead;
export type UsersPartialUpdateApiArg = {
  /** A unique integer value identifying this User. */
  id: number;
  patchedUserRequest: PatchedUserRequest;
};
export type UsersDestroyApiResponse = unknown;
export type UsersDestroyApiArg = {
  /** A unique integer value identifying this User. */
  id: number;
};


export type User = {
  first_name?: string;
  last_name?: string;
  is_active?: boolean;
  is_staff?: boolean;
  is_superuser?: boolean;
  customer: Customer;
  groups?: number[];
  /** Specific permissions for this user. */
  user_permissions?: number[];
  last_login?: string | null;
};
export type UserRead = {
  id: number;
  email: string;
  first_name?: string;
  last_name?: string;
  is_active?: boolean;
  is_staff?: boolean;
  is_superuser?: boolean;
  customer: CustomerRead;
  /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
  groups?: number[];
  /** Specific permissions for this user. */
  user_permissions?: number[];
  last_login?: string | null;
};
export type PaginatedUserList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: User[];
};
export type PaginatedUserListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: UserRead[];
};

export type CustomerRequest = {
  address: AddressRequest;
  company_name: string;
  company_contact_email: string;
};
export type UserRequest = {
  first_name?: string;
  last_name?: string;
  is_active?: boolean;
  is_staff?: boolean;
  is_superuser?: boolean;
  customer: CustomerRequest;
  /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
  groups?: number[];
  /** Specific permissions for this user. */
  user_permissions?: number[];
  last_login?: string | null;
};
export type PatchedUserRequest = {
  first_name?: string;
  last_name?: string;
  is_active?: boolean;
  is_staff?: boolean;
  is_superuser?: boolean;
  customer?: CustomerRequest;
  /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
  groups?: number[];
  /** Specific permissions for this user. */
  user_permissions?: number[];
  last_login?: string | null;
};
